import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_antd@3.1.1@antd/es/progress/index.js
// module id = null
// module chunks = 